import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Order } from '../../models/Order';
import { getOrdersByMe } from '../../state/order/order.actions';
import { selectGetOrders } from '../../state/order/order.selector';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.css'],
  standalone: true,
  imports: [CommonModule, MatTableModule, AsyncPipe, MatOptionModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule]
})
export class OrderHistoryComponent implements OnInit {
  orders$: Observable<Order[]>;
  years$: Observable<number[]>;
  selectedYear: number | null = null;

  constructor(private store: Store, private router: Router) {
    this.orders$ = this.store.pipe(select(selectGetOrders));
    this.years$ = this.orders$.pipe(
      map(orders => {
        const currentYear = new Date().getFullYear();
        return Array.from(new Set((orders || [])
          .map(o => o.createdDate ? new Date(o.createdDate).getFullYear() : null)
          .filter(y => y !== null && y !== currentYear)
        )).sort((a, b) => b! - a!) as number[];
      }),
      tap(years => {
        if (years.length > 0 && this.selectedYear !== years[0]) {
          this.selectedYear = years[0];
        }
      })
    );
  }

  ngOnInit(): void {
    this.store.dispatch(getOrdersByMe());
  }

  getFilteredOrders(orders: Order[]): Order[] {
    if (!this.selectedYear) return [];
    return orders.filter(o => o.createdDate && new Date(o.createdDate).getFullYear() === this.selectedYear);
  }

  navigateToDetails(order: Order) {
    this.router.navigate(['/orders', order.reflexOrderNo]);
  }

  back() {
    window.history.back();
  }
}
